import { ModalProvider, Portal } from '@genial/components';
import { Theme } from '@genial/themes';
import { NavigationContainer as NativeNavigationContainer } from '@react-navigation/native';
import { NativeBaseProvider } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { isSignedIn } from '../store/session/selector';

import { linking as signedInLinking } from './SignedIn';
import { linking as signedOutLinking } from './SignedOut';

import { Routes } from './index';

export const NavigationContainer = () => {
  const userSignedIn = useRecoilValue(isSignedIn);
  return (
    <NativeNavigationContainer linking={userSignedIn ? signedInLinking : signedOutLinking}>
      <NativeBaseProvider theme={Theme.Default}>
        <Portal.Provider>
          <ModalProvider>
            <Routes />
          </ModalProvider>
        </Portal.Provider>
      </NativeBaseProvider>
    </NativeNavigationContainer>
  );
};
